<div class="pmd-sidebar-scrollbar sidebar_submenu">
	<!-- Back Button for Nested Menu -->
	<div class="p-3 d-flex align-items-center"
		*ngIf="isNestedMenu">
		<button class="btn btn-sm btn-link p-0 me-2"
			(click)="goBackToParentMenu()"
			title="Go back">
			<svg width="20"
				height="20"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path d="M15 18L9 12L15 6"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round" />
			</svg>
		</button>
		<p class="p-0 mb-0 text-dark fw-semibold flex-grow-1">{{menu?.name}}</p>
	</div>

	<!-- Settings Header (when not in nested menu) -->
	<p class="p-3 mb-0 text-dark fw-semibold"
		*ngIf="!isNestedMenu">{{menu?.name}}</p>

	<ul class="nav flex-column pmd-sidebar-nav">
		<ng-container *ngFor="let submenu of menu?.subMenus">
			<li class="nav-item"
				routerLinkActive="active"
				[routerLinkActiveOptions]="{exact: true}"
				*ngIf="submenu">
				<a class="nav-link"
					quicklink
					[routerLink]="submenu.path || (submenu.subMenus?.length ? submenu.subMenus[0].path : null)"
					[routerLinkActive]="submenu.path ? 'active' : ''"
					[routerLinkActiveOptions]="{exact: true}"
					(click)="submenu.subMenus?.length ? openNestedMenu(submenu) : null">
					<span><i class="pmd-nav-item-icon"
							aria-hidden="true"
							*ngIf="submenu.svg"
							[innerHTML]="submenu.svg | safeHtml">
						</i></span>
					<span class="flex-grow-1"
						*ngIf="submenu.name"
						aria-hidden="true">{{submenu.name}}</span>
					<!-- Arrow indicator for items with submenus -->
					<span *ngIf="submenu.subMenus?.length"
						class="hide-on-brand">
						<svg width="6"
							height="11"
							viewBox="0 0 7 12"
							fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<g clip-path="url(#clip0_4453_14990)">
								<path
									d="M0.721623 0.262639C1.01452 -0.0302546 1.48928 -0.0302545 1.78217 0.262639L6.78217 5.26264C6.92282 5.40329 7.0019 5.594 7.0019 5.79291C7.0019 5.99182 6.92282 6.18253 6.78217 6.32319L1.78217 11.3232C1.48928 11.6161 1.01451 11.6161 0.721623 11.3232C0.428737 11.0303 0.428747 10.5555 0.721623 10.2626L5.19135 5.79291L0.721623 1.32319C0.42873 1.03029 0.42873 0.555532 0.721623 0.262639Z"
									fill="#373737" />
							</g>
							<defs>
								<clipPath id="clip0_4453_14990">
									<rect width="7"
										height="12"
										fill="white" />
								</clipPath>
							</defs>
						</svg>
					</span>
				</a>
			</li>
		</ng-container>
	</ul>
</div>